var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "battery-status-level" }, [
      _c("div", [
        _c("div", [
          _c("div", { attrs: { id: "battery-charge-level-chart-container" } })
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }